const API_BASE = process.env.REACT_APP_API_URL || '';

export async function getComplianceDocs(orgId, filters = {}) {
  const params = new URLSearchParams();
  
  if (filters.programId) params.append('programId', filters.programId);
  if (filters.siteId) params.append('siteId', filters.siteId);
  if (filters.assetId) params.append('assetId', filters.assetId);
  if (filters.category) params.append('category', filters.category);
  if (filters.search) params.append('search', filters.search);
  
  const queryString = params.toString();
  const url = `${API_BASE}/orgs/${orgId}/compliance-docs${queryString ? '?' + queryString : ''}`;
  
  const response = await fetch(url, {
    credentials: 'include',
    headers: {
      'x-org-id': orgId
    }
  });
  
  if (!response.ok) {
    if (response.status === 403) {
      throw new Error('You do not have permission to view compliance documents');
    }
    throw new Error('Failed to fetch compliance documents');
  }
  
  const data = await response.json();
  return data.docs;
}

export async function getComplianceDoc(orgId, docId) {
  const response = await fetch(`${API_BASE}/orgs/${orgId}/compliance-docs/${docId}`, {
    credentials: 'include',
    headers: {
      'x-org-id': orgId
    }
  });
  
  if (!response.ok) {
    if (response.status === 404) {
      throw new Error('Document not found');
    }
    throw new Error('Failed to fetch document');
  }
  
  const data = await response.json();
  return data.doc;
}

export async function getDocVersions(orgId, docId) {
  const response = await fetch(`${API_BASE}/orgs/${orgId}/compliance-docs/${docId}/versions`, {
    credentials: 'include',
    headers: {
      'x-org-id': orgId
    }
  });
  
  if (!response.ok) {
    if (response.status === 404) {
      throw new Error('Document not found');
    }
    throw new Error('Failed to fetch document versions');
  }
  
  const data = await response.json();
  return data.versions;
}

export async function uploadComplianceDoc(orgId, data) {
  const response = await fetch(`${API_BASE}/orgs/${orgId}/compliance-docs`, {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      'x-org-id': orgId
    },
    body: JSON.stringify(data)
  });
  
  if (!response.ok) {
    if (response.status === 403) {
      throw new Error('You do not have permission to upload documents');
    }
    throw new Error('Failed to upload document');
  }
  
  return response.json();
}

export async function logDocDownload(orgId, docId, version) {
  const response = await fetch(`${API_BASE}/orgs/${orgId}/compliance-docs/${docId}/download`, {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      'x-org-id': orgId
    },
    body: JSON.stringify({ version })
  });
  
  if (!response.ok) {
    throw new Error('Failed to log download');
  }
  
  return response.json();
}
